import { GoogleButton } from './GoogleButton'

export { GoogleButton }



// WEBPACK FOOTER //
// ./client/Modules/AppAuthPage/containers/index.js